import { useMemo } from 'react';
import { useCurrentFrame } from '~/systems/currentFrame';
import { useTitleRef } from '~/systems/title';
import './ErrorEst.css';

export default function ErrorEst() {
  const currentFrame = useCurrentFrame();
  const titleRef = useTitleRef<HTMLDivElement>(
    'an estimate of emulation accuracy'
  );

  const errorEstText = useMemo(() => {
    const error = currentFrame.logErrorEst;
    if (error === null) {
      return '';
    }
    return (Math.exp(-error) * 100).toFixed(1) + '%';
  }, [currentFrame]);

  if (currentFrame.logErrorEst == null) {
    return null;
  }

  return (
    <div ref={titleRef} className="ErrorEst">
      accuracy: <span>{errorEstText}</span>
    </div>
  );
}
